import { useEffect, useState } from 'react'

export default function useScreenSize() {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    if (typeof window !== undefined) {
      setIsMobile(window.screen.width <= 1025)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { isMobile }
}
